import React, { useEffect, useState } from "react";
import { useRef } from "react";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import { toast } from "react-toastify";
import { ToastContainer } from "react-toastify";
import { useNavigate, useLocation } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import {
  getdrpBedTypeMst,
  getdrpRoomMst,
  getPropertyMstUserwisedrp,
  insertRoomBedMst,
  retriveRoomBedMst,
  updateRoomBedMst,
} from "../../../../Api/RoomMst/Api";
import { getFormMode } from "../../../../lib/helpers";
import { formatDeleteErrorMessage } from "../../../../GlobalFunction/ErrorMessageHelper";
import UnLock from "../../../../GlobalFunction/UnLock";
import checkAndLock from "../../../../GlobalFunction/checkAndLock";
import {
  Autocomplete,
  Checkbox,
  FormControlLabel,
  FormGroup,
  InputAdornment,
} from "@mui/material";
import CrudButtons from "../../../../../src/GlobalFunction/CrudButtons";
import { z } from "zod";
import { useReactToPrint } from "react-to-print";
import axiosInstance from "../../../../lib/axios";
import AddIcon from "@mui/icons-material/Add";
import RefreshIcon from "@mui/icons-material/Refresh";
import CustomAutocomplete from "../../../AutoComplete/AutocompletewithoutIcon";
import ReportTable from "../../../../atoms/ReportFolder/ReportTable";

const FORM_MODE = getFormMode();
const FORM_INIT_STATE = {
  RoombedName: "",
  BedRent: "",
  RoomBedTypeId: "",
  Remark: "",
  RoomId: "",
  PropId: "",
  Status: FORM_MODE.add ? "1" : "0",
};
const columns = [
  { id: "RowNum", label: "Sr.No.", minWidth: 3 },
  { id: "PropName", label: "Property", minWidth: 100 },
  { id: "WingName", label: "Wing", minWidth: 40 },
  { id: "FloorName", label: "Floor", minWidth: 60 },
  { id: "RoomTypeName", label: "RoomType", minWidth: 60 },
  { id: "RoomNo", label: "RoomNo", minWidth: 10 },
  { id: "TotalBeds", label: "TotalBeds", minWidth: 40 },
  { id: "RoombedName", label: "BedNo", minWidth: 40 },
  { id: "RoomBedTypeName", label: "BedType", minWidth: 40 },
  { id: "BedRent", label: "BedRent", minWidth: 80 },
  { id: "Status", label: "Status", minWidth: 20 },
];
const bedFormSchema = z.object({
  RoombedName: z.union([z.string().min(1, "Bed No. is required"), z.number()]),
  BedRent: z.number().min("1", "BedRent is required"),
  RoomBedTypeId: z.number().min("1", "RoomType is required"),
  RoomId: z.number().min(1, " Room No. is required"),
  PropId: z.number().min(1, "Property is required"),
  Remark: z.string().optional(),
  Status: z.enum(["0", "1"]).optional(),
});
const RoomBedNumber = () => {
  const [UserId] = useState(sessionStorage.getItem("UserId"));
  const navigate = useNavigate();
  const location = useLocation();
  const [form, setForm] = useState(FORM_INIT_STATE);
  const [properties, setProperties] = useState([]);
  const [Status, setStatus] = useState("1");
  const [isRefreshBedTyp, setIsRefreshBedTyp] = useState(false);

  const [error, setError] = useState({
    roomId: false,
    roombedName: false,
    remark: false,
  });

  const [propId] = useState(() => {
    return location?.state?.PropId;
  });
  const [currentRoomBedId, setCurrentRoomBedId] = useState(() => {
    return location?.state?.RoomBedId;
  });
  const [mode, setMode] = useState(() =>
    currentRoomBedId ? FORM_MODE.read : FORM_MODE.add
  );

  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [roomType, setRoomType] = useState([]);
  const [roomNo, setRoomNo] = useState([]);

  const [DataForPrint, setDataForPrint] = useState({});
  const [rows, setRows] = useState([]);
  const contentRef = useRef(null);
  const handlePrint = useReactToPrint({ contentRef });

  const roombedNameRef = useRef(null);
  const remarkRef = useRef(null);

  const spinAnimation = {
    animation: isRefreshBedTyp ? 'spin 1s linear infinite' : 'none',
  };

  const openBedTypTab = () => {
    window.open("/roomBedType");
  };

  const handleRefreshBedTyp = async () => {
    setIsRefreshBedTyp(true);
    try {
      const response = await axiosInstance.post(`RoomBedTypeMst/getdrpBedTypeMst`);
      const { data: { Status, Data } } = response;
      if (Status === 0 && Array.isArray(Data)) {
        setRoomType(Data);
      }
      // else {
      //   setRoomType([]);
      // }
    } catch (error) {
      console.error("Error refreshing job titles:", error)
    } finally {
      setTimeout(() => {
        setIsRefreshBedTyp(false);
      }, 300);
    }
  };

  const handleChangeStatus = (event) => {
    const updatedStatus = event.target.checked ? "1" : "0";
    setStatus(updatedStatus);
    setForm((prevState) => ({
      ...prevState,
      Status: updatedStatus,
    }));
  };

  useEffect(() => {
    const getRow = async () => {
      try {
        const res = await axiosInstance.post('RoomBedMst/getAllRoomBedMstDashBoard', {
          start: 1,
          PageSizea: 1,
          SearchText: "",
        });
        if (res.data && res.data.Data) {
          setRows(res.data.Data);
          setDataForPrint(res.data.Data);
        } else {
          console.error('No data found in response');
        }
      } catch (err) {
        console.error('Error fetching data:', err);
      }
    };

    getRow();
  }, []);

  //drpdownroomtype
  useEffect(() => {
    (async () => {
      const response = await getdrpBedTypeMst();
      if (response instanceof Error) {
        return console.error(response.message);
      }
      const {
        data: { Status, responseStatusCode, Data },
      } = response;
      if (Status === 0 && responseStatusCode === 1 && Array.isArray(Data)) {
        console.log("roomtypeid", Data);
        setRoomType(Data);
      } else {
        return toast.error("Error: RoomType not found");
      }
    })();
  }, []);

  //drp property userwise
  useEffect(() => {
    const UserId = sessionStorage.getItem("UserId");

    if (!UserId) {
      toast.error("Error: userId is missing in session");
      return;
    }
    (async () => {
      const response = await getPropertyMstUserwisedrp({
        Flag: "",
        UserId,
      });
      if (response instanceof Error) {
        return console.error("Error Properties could not be fetched");
      } else {
        const {
          data: { Status, Data },
        } = response;
        if (Status === 0 && Array.isArray(Data) && Data.length > 0) {
          setProperties(Data);
        } else {
          return toast.error("Error:Properties not found");
        }
      }
    })();
  }, []);

  //drpdownroomno
  useEffect(() => {
    if (form.PropId) {
      (async () => {
        const response = await getdrpRoomMst({
          RoomBedTypeId: 0,
          PropId: form.PropId,
          Flag: "PR",
        });
        if (response instanceof Error) {
          return console.error("Error:Could not fetch Room No.");
        }
        const {
          data: { Status, responseStatusCode, Data },
        } = response;
        if (Status === 0 && responseStatusCode === 1 && Array.isArray(Data)) {
          console.log("roomBedTypeid", Data);
          setRoomNo(Data);
        } else {
          return toast.error("Error: Room No. not found");
        }
      })();
    }
  }, [form.PropId]);

  //For Retrive
  useEffect(() => {
    if (currentRoomBedId) {
      fetchRoomBedNumberData();
    }
  }, []);

  const handlePrevious = async () => {
    if (!currentRoomBedId && currentRoomBedId < 1) return;
    await fetchRoomBedNumberData("P");
  };

  const handleNext = async () => {
    if (!currentRoomBedId) return;
    await fetchRoomBedNumberData("N");
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;

    // Log the name and value of the input field
    console.log("Input Change - Name:", name, "Value:", value);
    let parsedValue;




    if (name === "PropId" || name === "RoomId") {
      parsedValue = parseInt(value, 10);
    }
    if (name === "RoomBedTypeId") {
      parsedValue = value ? parseInt(value, 10) : null;
    }
    else if (name === "BedRent") {
      parsedValue = value ? parseFloat(value) : 0;
    }
    else if (name === "RoombedName") {
      parsedValue = isNaN(value) ? value : parseFloat(value);
    } else {
      parsedValue = value;
    }
    setForm((prevState) => ({
      ...prevState,
      [name]: parsedValue,
    }));
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      if (event.target === roombedNameRef.current) {
        remarkRef.current.focus();
      } else {
        roombedNameRef.current.focus();
      }
    }
  };

  const handleEdit = async () => {
    let Flag = await checkAndLock(currentRoomBedId, "MstRoomBed", "RoomBedId");
    switch (Flag) {
      case 0:
        // setIsFormDisabled(false);
        setMode(FORM_MODE.edit);
        break;
      case 1:
        toast.info("Record  Already Locked", { autoClose: 500 });
        break;
      case 2:
        toast.info("Record Failed To Locked", { autoClose: 500 });
        break;
      default:
        toast.info("Something Went Wrong", { autoClose: 500 });
    }
  };

  const handleAdd = () => {
    setStatus("1");
    setMode(FORM_MODE.add);
    setForm(FORM_INIT_STATE);
  };

  const handleCancel = async (flag = "L") => {
    if (mode === FORM_MODE.add) {
      await fetchRoomBedNumberData("L", 1);
    } else {
      await UnLock(currentRoomBedId, "MstRoomBed", "RoomBedId");
      await fetchRoomBedNumberData("R");
    }
    setMode(FORM_MODE.read);
  };

  const handleExit = () => {
    if (!form.PropId) {
      return navigate(-1);
    }
    navigate(`/RoomBedNumbertable?propId=${form.PropId}`);
  };

  const handleDelete = async () => {
    let Flag = await checkAndLock(currentRoomBedId, "MstRoomBed", "RoomBedId");
    switch (Flag) {
      case 0:
        setOpenConfirmDialog(true);
        break;
      case 1:
        toast.info("Record Already Locked", { autoClose: 500 });
        break;
      case 2:
        toast.info("Record Failed To Locked", { autoClose: 500 });
        break;
      default:
        toast.info("Something Went Wrong", { autoClose: 500 });
    }
  };

  const handleCloseConfirmDialog = () => {
    setOpenConfirmDialog(false);
  };

  const handleConfirmDelete = async () => {
    setOpenConfirmDialog(false);
    try {
      const response = await retriveRoomBedMst({
        RoomBedId: currentRoomBedId,
        Flag: "D",
      });
      if (response instanceof Error) {
        return toast.error("Error: could not delete room");
      }
      const {
        data: { Status, Message, Data },
      } = response;
      if (Status === 0) {
        toast.success(Message, { autoClose: 500 });
        await fetchRoomBedNumberData("N");
      } else {
        if (Array.isArray(Data) && Data.length > 0) {
          const msg = formatDeleteErrorMessage(Data);
          toast.error(msg, { autoClose: 1000 });
        } else {
          toast.error(Message, { autoClose: 1000 });
        }
      }
      await UnLock(currentRoomBedId, "MstRoomBed", "RoomBedId");
    } catch (error) {
      console.log(error);
    }
  };

  const fetchRoomBedNumberData = async (flag = "R", RoomBedId) => {
    const response = await retriveRoomBedMst({
      RoomBedId: currentRoomBedId,
      Flag: flag,
    });
    if (response instanceof Error) {
      console.log(response.message);
    }

    const {
      data: { Status, responseStatusCode, Data, Message },
    } = response;
    if (Status === 0 && responseStatusCode === 1) {
      setForm({
        Remark: Data[0]?.Remark,
        RoomBedTypeId: Data[0]?.RoomBedTypeId,
        RoomId: Data[0]?.RoomId,
        RoombedName: Data[0]?.RoombedName,
        BedRent: Data[0]?.BedRent ?? "",
        PropId: Data[0]?.PropId,
        Status: Data[0]?.Status,
      });
      setStatus(Data[0]?.Status);
      setMode(FORM_MODE.read);
      setCurrentRoomBedId(Data[0]?.RoomBedId);
    } else {
      console.log(Message);
    }
  };

  const handleSubmit = async () => {
    const result = bedFormSchema.safeParse(form);
    if (!result.success) {
      console.log("Validation Errors:", result.error.format());
      return toast.info("Please fill in all required inputs correctly", {
        autoClose: 1000,
      });
    }
    const { data } = result;
    const payload = {
      RoomId: data.RoomId,
      RoomBedTypeId: data.RoomBedTypeId,
      RoombedName: data.RoombedName,
      Status: data.Status,
      BedRent: data.BedRent,
      Remark: data.Remark,
      PropId: data.PropId,
    };

    let response;
    if (mode === FORM_MODE.edit && currentRoomBedId) {
      payload.RoomBedId = currentRoomBedId;
      payload.UpdatedBy = UserId;
      await UnLock(currentRoomBedId, "MstRoomBed", "RoomBedId");
      response = await updateRoomBedMst(payload);
    } else {
      payload.CreatedBy = UserId;
      response = await insertRoomBedMst(payload);
    }

    if (response instanceof Error) {
      toast.error("Error:Could not submit form");
    }
    const {
      data: { Status, Message },
    } = response;
    if (Status === 0) {
      setMode(FORM_MODE.read);
      toast.success(Message, {
        autoClose: 1000,
      });
    } else {
      toast.error(Message, { autoClose: 1000 });
    }
  };

  // useEffect(() => {
  //   if (form.RoomId) {
  //     const foundRoom = roomNo.find((r) => r.Id === form.RoomId);
  //     if (foundRoom) {
  //       setForm((prev) => ({
  //         ...prev,
  //         BedRent: parseInt(foundRoom.Value, 10),
  //       }));
  //     }
  //   }
  // }, [form.RoomId, roomNo]);

  useEffect(() => {
    if (mode === FORM_MODE.add && !currentRoomBedId && propId) {
      setForm({ ...form, PropId: propId });
    }
  }, [currentRoomBedId]);

  return (
    <>
      <ToastContainer />
      <Box className="form-container">
        <Grid container spacing={2} className="form_grid">
          <Grid
            item
            xs={12}
            className="form_title"
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginTop: "20px",
              flexDirection: { xs: "column", sm: "row", md: "row" },
            }}
          >
            <Grid
              sx={{
                display: "flex",
                justifyContent: { xs: "center", sm: "flex-start" },
                marginBottom: { xs: "10px", sm: 0 },
              }}
            >
              <Button
                variant="contained"
                size="small"
                sx={{
                  backgroundColor: "#635bff",
                  marginRight: { xs: "5px", sm: "10px" },
                  display: "block",
                }}
                className="three-d-button-previous"
                onClick={handlePrevious}
                disabled={
                  mode !== FORM_MODE.read ||
                  !currentRoomBedId ||
                  currentRoomBedId === 1
                }
              >
                <KeyboardArrowLeftIcon />
              </Button>

              <Button
                variant="contained"
                size="small"
                sx={{
                  backgroundColor: "#635bff",
                  display: "block",
                }}
                className="three-d-button-next"
                onClick={handleNext}
                disabled={mode !== FORM_MODE.read}
              >
                <NavigateNextIcon />
              </Button>
            </Grid>
            <h3
              sx={{
                margin: "Auto",
                textAlign: { xs: "center", sm: "center" },
                fontSize: { xs: "24px", sm: "18px", md: "24px" },
              }}
            >
              Bed Master
            </h3>

            <Grid sx={{ display: "flex", justifyContent: "end" }}>
              <CrudButtons
                moduleName="Bed Master"
                mode={mode}
                onAdd={handleAdd}
                onEdit={handleEdit}
                onView={handlePrint}
                onDelete={handleDelete}
                onExit={handleExit}
                onPrevious={handlePrevious}
                onNext={handleNext}
                readOnlyMode={mode === FORM_MODE.read}
              />
            </Grid>
          </Grid>

          <Grid item xs={12} className="form_field">
            <Grid container spacing={2}>
              <Grid item xs={12} md={3} lg={6}>
                <CustomAutocomplete
                  id="property-select"
                  name="PropId"
                  label={
                    <span>
                      Property<span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  options={properties}
                  value={
                    properties.find((property) => property.Id == form.PropId) ||
                    ''
                  }

                  onChange={handleInputChange}


                  disabled={mode === FORM_MODE.read || mode === FORM_MODE.edit}
                />
              </Grid>
              <Grid item xs={12} md={3} lg={6}>


                <CustomAutocomplete
                  id="roomBedType-select"
                  name="RoomBedTypeId"
                  options={roomType}
                  value={roomType.find((type) => type.Id === form.RoomBedTypeId) || ''}
                  onChange={handleInputChange}


                  label={
                    <span>
                      Room Bed Type <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  disabled={mode === FORM_MODE.read}
                  onAddClick={openBedTypTab}
                  onRefreshClick={handleRefreshBedTyp}
                  isRefreshing={isRefreshBedTyp}
                />
              </Grid>

              <Grid item xs={12} md={6} lg={6}>
                <CustomAutocomplete
                  id="roomId-select"
                  name="RoomId"
                  label={
                    <span>
                      Room No.<span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  options={roomNo}
                  value={roomNo.find((room) => room.Id === form.RoomId) || ''}

                  onChange={handleInputChange}
                  disabled={mode === FORM_MODE.read || mode === FORM_MODE.edit}
                />
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={3} lg={6}>
                    <TextField
                      id="roombedName"
                      name="RoombedName"
                      label={
                        <span>
                          Bed No.<span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      variant="filled"
                      fullWidth
                      className="custom-textfield"
                      value={form.RoombedName}
                      onChange={handleInputChange}
                      disabled={mode === FORM_MODE.read}
                      error={error.roombedName}
                      helperText={error.roombedName && ""}
                      inputRef={roombedNameRef}
                      onKeyDown={handleKeyPress}
                    />
                  </Grid>
                  <Grid item xs={12} md={3} lg={6}>
                    <TextField
                      id="BedRent"
                      name="BedRent"
                      label={
                        <span>
                          Bed Rent<span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      variant="filled"
                      fullWidth
                      className="custom-textfield"
                      value={form.BedRent}
                      onChange={handleInputChange}
                      disabled={mode === FORM_MODE.read}
                      error={error.roombedName}
                      helperText={error.roombedName && ""}
                      inputRef={roombedNameRef}
                      onKeyDown={handleKeyPress}
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} md={6} lg={6}>
                <TextField
                  id="remark"
                  name="Remark"
                  label="Remark"
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  value={form.Remark}
                  onChange={handleInputChange}
                  disabled={mode === FORM_MODE.read}
                  error={error.remark}
                  helperText={error.remark && ""}
                  inputRef={remarkRef}
                />
              </Grid>
              <Grid item xs={12} md={2} lg={2}>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        disabled={mode === FORM_MODE.read}
                        checked={Status === "1"}
                        onChange={handleChangeStatus}
                      />
                    }
                    label="Status"
                  />
                </FormGroup>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} className="form_button">
            {mode === FORM_MODE.read && (
              <>
                <Button
                  variant="contained"
                  sx={{
                    mr: 1,
                    background: "linear-gradient(290deg, #d4d4d4, #ffffff)",
                    //background: "linear-gradient(290deg, #b9d0e9, #e9f2fa)",
                  }}
                  onClick={handleAdd}
                  disabled
                >
                  Submit
                </Button>
                <Button
                  variant="contained"
                  sx={{
                    mr: 1,
                    background: "linear-gradient(290deg, #a7c5e9, #ffffff)",
                    // background: "linear-gradient(290deg, #b9d0e9, #e9f2fa)",
                  }}
                  onClick={handleEdit}
                  // disabled={!currentZoneId}
                  disabled
                >
                  Cancel
                </Button>
              </>
            )}
            {(mode === FORM_MODE.edit || mode === FORM_MODE.add) && (
              <>
                <Button
                  variant="contained"
                  sx={{
                    mr: 1,
                    background: "linear-gradient(290deg, #b9d0e9, #e9f2fa)",
                  }}
                  onClick={handleSubmit}
                >
                  Submit
                </Button>
                <Button
                  variant="contained"
                  sx={{
                    mr: 1,
                    background: "linear-gradient(290deg, #b9d0e9, #e9f2fa)",
                  }}
                  onClick={handleCancel}
                >
                  Cancel
                </Button>
              </>
            )}
          </Grid>
        </Grid>
      </Box>

      <div style={{ display: "none" }}>
        {rows.length > 0 && (
          <ReportTable
            columns={columns}
            rows={rows.map(row => ({
              ...row,
              Status: row.Status === "1" ? "Active" : row.Status === "0" ? "Inactive" : row.Status,
            }))}
            title="Bed Master Report "
            contentRef={contentRef}
            customStyles={{ backgroundColor: "#f5f5f5" }}
          />
        )}
      </div>
      {/* Delete Confirmation Modal */}
      <Dialog
        open={openConfirmDialog}
        onClose={handleCloseConfirmDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Confirm Deletion"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this record?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            sx={{
              backgroundColor: "#635bff",
              color: "white",
              "&:hover": {
                backgroundColor: "#1565c0",
                color: "white",
              },
            }}
            onClick={handleConfirmDelete}
          >
            Yes
          </Button>
          <Button
            sx={{
              backgroundColor: "#635bff",
              color: "white",
              "&:hover": {
                backgroundColor: "#1565c0",
                color: "white",
              },
            }}
            onClick={handleCloseConfirmDialog}
          >
            No
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default RoomBedNumber;
